import { useEffect, useState } from 'react';
import axiosInstance from 'utils/axiosInterceptors';
import { TProductCategoryDetails } from 'utils/types';

const useGetProductCategory = (leavesOnly = false) => {
  const [productCategories, setProductCategories] = useState<
    TProductCategoryDetails[]
  >([]);

  useEffect(() => {
    const getProductCategories = async () => {
      const { data } = await axiosInstance.get(
        `/api/v1/productCategories?page=1&pageSize=2000${
          leavesOnly ? '&leavesOnly=true' : ''
        }`
      );
      setProductCategories(data.data);
    };
    getProductCategories();
  }, [leavesOnly]);

  return { productCategories };
};

export default useGetProductCategory;
